import { el } from "../lib/dom";

/** Full-page Hub maintenance notice — shown to non-super-admins (and logged-out
 *  visitors) while Hub-level maintenance is on. No login, no app grid. */
export function renderMaintenance(message: string | null): HTMLElement {
  return el("main", { class: "maintenance-page" }, [
    el("div", { class: "maintenance-card" }, [
      el("div", { class: "maintenance-mark" }, ["🔧"]),
      el("h1", {}, ["Hub is under maintenance"]),
      el("p", { class: "muted" }, [
        message || "We're doing some scheduled work and will be back shortly. Thanks for your patience.",
      ]),
    ]),
  ]);
}
